import { createStyles } from '@mantine/core';

const useGlobalCustomStyles = createStyles(theme => ({
  tableTitleSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.other.colors.bgDark : theme.other.colors.bgLight,
    paddingBottom: theme.spacing.sm,
    marginBottom: theme.spacing.md,
    color:
      theme.colorScheme === 'dark'
        ? `${theme.white[1]} !important`
        : `${theme.other.colors.appBlue} !important`,
  },
  tableTitle: {
    color:
      theme.colorScheme === 'dark'
        ? `${theme.colors.dark[0]} !important`
        : `${theme.other.colors.appBlue} !important`,
  },
  actionIconBlue: {
    color: `${theme.colors.blue[7]} !important`,
  },
  actionIconRed: {
    color: `${theme.colors.softPink[7]} !important`,
  },
  actionIconEnabled: {
    border: `1px solid`,
    borderRadius: theme.radius.sm,
    color: `${theme.colors.blue[6]} !important`,
    lineHeight: 1,
    '&:hover': {
      backgroundColor: `${
        theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.blue[0]
      } !important`,
    },
  },
  actionIconDisabled: {
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
    border: `1px solid transparent`,
    borderRadius: theme.radius.sm,
    color: `${theme.colors.gray[6]} !important`,
    cursor: 'default',
    lineHeight: 1,
  },
}));

export default useGlobalCustomStyles;
